import {ChangeDetectionStrategy, Component, Injectable} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatIcon} from "@angular/material/icon";

const debug = initDebugger('MeldingSendtIkonKomponent');

/**
 * Viser et stort 'melding sendt' ikon
 */
@Component({
    selector: 'melding-sendt-ikon',
    template: '<mat-icon svgIcon="sf:epost-sendt"/>',
    styleUrl: 'melding-sendt-ikon.scss',
    imports: [MatIcon],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MeldingSendtIkonKomponent {
}

@Injectable()
export class MeldingSendtIkonKomponentAvhengigheter {

    constructor() {
    }

}
